var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "movieConfig" },
    [
      _c("div", { staticClass: "profit-box" }, [
        _c("div", { staticClass: "profit" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v("渠道级规则（商品中心）"),
          ]),
          _c("div", [
            _vm._v(
              "上架影院：" + _vm._s(_vm.settingsInfo.on_cinema_count) + "个"
            ),
          ]),
          _c("div", [
            _vm._v(
              "下架影院：" + _vm._s(_vm.settingsInfo.off_cinema_count) + "个"
            ),
          ]),
        ]),
        _c("div", { staticClass: "profit" }, [
          _c("div", { staticClass: "title" }, [_vm._v("客户级规则")]),
          _c("div", [_vm._v("价格区间：" + _vm._s(_vm.priceRange.join("~")))]),
          _c(
            "div",
            [
              _vm._v(
                " 影院黑名单：" +
                  _vm._s(
                    _vm.settingsInfo.black_cinema_count > 0
                      ? _vm.settingsInfo.black_cinema_count + "个"
                      : "未设置"
                  ) +
                  " "
              ),
              _vm.settingsInfo.black_cinema_count > 0
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "text" },
                      on: {
                        click: function ($event) {
                          return _vm.openDialog("cinema")
                        },
                      },
                    },
                    [_vm._v(" 查看明细 ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            [
              _vm._v(" 影片黑/白名单：" + _vm._s(_vm.blackMovieCount) + " "),
              ["1", "2"].includes(_vm.settingsInfo.movie_setting_type + "")
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "text" },
                      on: {
                        click: function ($event) {
                          return _vm.openDialog("movie")
                        },
                      },
                    },
                    [_vm._v(" 查看明细 ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "profit" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v("订单级影厅关键词黑名单"),
          ]),
          _c("div", [
            _vm._v(
              " 黑名单：" +
                _vm._s(
                  _vm.keywordTotal < 1 ? "未设置" : _vm.keywordTotal + "个"
                ) +
                " "
            ),
          ]),
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "text" },
                  on: {
                    click: function ($event) {
                      return _vm.openDialog("viewMovieKeyword")
                    },
                  },
                },
                [
                  _vm._v(
                    " 查看" +
                      _vm._s(_vm.movieType === "view" ? "明细" : "") +
                      " "
                  ),
                ]
              ),
              _vm.movieType === "set" && _vm.hasEditRule
                ? [
                    _c("el-divider", { attrs: { direction: "vertical" } }),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.openDialog("setMovieKeyword")
                          },
                        },
                      },
                      [_vm._v(" 设置黑名单 ")]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]),
        _c("div", { staticClass: "profit" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v("订单级城市/影院白名单"),
          ]),
          _c("div", [_vm._v(_vm._s(_vm.whiteCount))]),
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "text" },
                  on: {
                    click: function ($event) {
                      return _vm.openDialog("viewWhiteMovie")
                    },
                  },
                },
                [
                  _vm._v(
                    " 查看" +
                      _vm._s(_vm.movieType === "view" ? "明细" : "") +
                      " "
                  ),
                ]
              ),
              _vm.movieType === "set" && _vm.hasEditRule
                ? [
                    _c("el-divider", { attrs: { direction: "vertical" } }),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.openDialog("setWhiteMovie")
                          },
                        },
                      },
                      [_vm._v(" 设置白名单 ")]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "profit brand" },
        [
          _c("div", { staticClass: "title" }, [
            _vm._v("可用品牌" + _vm._s(_vm.totalCount) + "个"),
          ]),
          _c(
            "el-form",
            { ref: "searchForm", attrs: { model: _vm.searchForm, inline: "" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "城市", prop: "region_id" } },
                [
                  _c("el-cascader", {
                    staticStyle: { width: "120px" },
                    attrs: {
                      options: _vm.citys,
                      props: {
                        checkStrictly: true,
                        emitPath: false,
                        expandTrigger: "hover",
                      },
                      clearable: "",
                      filterable: "",
                      "popper-class": "city-style",
                    },
                    model: {
                      value: _vm.searchForm.region_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "region_id", $$v)
                      },
                      expression: "searchForm.region_id",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "影院", prop: "cinema_name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入影院名称", clearable: "" },
                    model: {
                      value: _vm.searchForm.cinema_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "cinema_name", $$v)
                      },
                      expression: "searchForm.cinema_name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "is_on_shelf" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "" },
                      model: {
                        value: _vm.searchForm.is_on_shelf,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "is_on_shelf", $$v)
                        },
                        expression: "searchForm.is_on_shelf",
                      },
                    },
                    [
                      _c("el-option", { attrs: { value: "", label: "全部" } }),
                      _c("el-option", { attrs: { value: "1", label: "上架" } }),
                      _c("el-option", { attrs: { value: "0", label: "下架" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.searchData("", "searchForm")
                        },
                      },
                    },
                    [_vm._v(" 搜索 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.searchData("reset", "searchForm")
                        },
                      },
                    },
                    [_vm._v(" 重置 ")]
                  ),
                  _vm.hasExportRole
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            exportLoading: _vm.exportLoading,
                            type: "success",
                          },
                          on: { click: _vm.exportData },
                        },
                        [_vm._v(" 导出 ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "right", "margin-bottom": "10px" } },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.searchForm.page,
                  "page-size": _vm.searchForm.pagesize,
                  "page-sizes": [10, 20, 30, 40, 50, 100],
                  total: _vm.totalCount,
                },
                on: {
                  "size-change": function (size) {
                    return _vm.sizeChange(size, "searchForm")
                  },
                  "current-change": function (page) {
                    return _vm.pageChange(page, "searchForm")
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticClass: "myTable",
              attrs: {
                "header-cell-style": {
                  background: "#f1f1f1",
                  color: "#333333",
                },
                data: _vm.tableData,
                height: "58vh",
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "省市区" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(scope.row.province_name) +
                            "/" +
                            _vm._s(scope.row.city_name) +
                            "/" +
                            _vm._s(scope.row.area_name) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "standard_id", label: "影院编码" },
              }),
              _c("el-table-column", {
                attrs: { prop: "cinema_name", label: "影院名称" },
              }),
              _c("el-table-column", {
                attrs: { prop: "cinema_address", label: "影院地址" },
              }),
              _c("el-table-column", {
                attrs: { prop: "is_on_shelf", label: "状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            style: {
                              color: scope.row.is_on_shelf == "0" ? "red" : "",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.is_on_shelf ? "上架" : "下架"
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.customerDialog,
            title: _vm.dialogTitle,
            "lock-scroll": "",
            "append-to-body": "",
            "destroy-on-close": "",
            top: "20px",
            width: "1000px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.customerDialog = $event
            },
            close: _vm.onDialogClose,
          },
        },
        [
          _c(
            "el-form",
            { ref: "dialogForm", attrs: { model: _vm.dialogForm, inline: "" } },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.dialogType === "cinema",
                      expression: "dialogType === 'cinema'",
                    },
                  ],
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "城市", prop: "city_id" } },
                    [
                      _c("el-cascader", {
                        attrs: {
                          options: _vm.citys,
                          props: {
                            checkStrictly: true,
                            emitPath: false,
                            expandTrigger: "hover",
                          },
                          clearable: "",
                          filterable: "",
                          "popper-class": "city-style",
                        },
                        model: {
                          value: _vm.dialogForm.city_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.dialogForm, "city_id", $$v)
                          },
                          expression: "dialogForm.city_id",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "影院", prop: "cinema_name" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入影院名称", clearable: "" },
                        model: {
                          value: _vm.dialogForm.cinema_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.dialogForm, "cinema_name", $$v)
                          },
                          expression: "dialogForm.cinema_name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", icon: "el-icon-search" },
                          on: {
                            click: function ($event) {
                              return _vm.searchData("", "dialogForm")
                            },
                          },
                        },
                        [_vm._v(" 搜索 ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-table",
            {
              staticClass: "myTable",
              attrs: {
                "header-cell-style": {
                  background: "#f1f1f1",
                  color: "#333333",
                },
                data: _vm.dialogTableData,
                height: "59vh",
                border: "",
              },
            },
            [
              _vm.dialogType === "cinema"
                ? [
                    _c("el-table-column", {
                      key: "standard_id",
                      attrs: { prop: "standard_id", label: "影院编码" },
                    }),
                    _c("el-table-column", {
                      key: "province_name",
                      attrs: { prop: "province_name", label: "省市区" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(scope.row.province_name) +
                                    "/" +
                                    _vm._s(scope.row.city_name) +
                                    "/" +
                                    _vm._s(scope.row.area_name) +
                                    " "
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1120523407
                      ),
                    }),
                    _c("el-table-column", {
                      key: "cinema_name",
                      attrs: { prop: "cinema_name", label: "影院名称" },
                    }),
                  ]
                : _vm._e(),
              _vm.dialogType === "movie"
                ? [
                    _c("el-table-column", {
                      key: "id",
                      attrs: { prop: "id", label: "ID" },
                    }),
                    _c("el-table-column", {
                      key: "movie_name",
                      attrs: { prop: "movie_name", label: "影片名称" },
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm.dialogType === "cinema"
            ? _c(
                "div",
                {
                  staticStyle: { "text-align": "right", "margin-top": "10px" },
                },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      layout: "total, sizes, prev, pager, next, jumper",
                      "current-page": _vm.dialogForm.page,
                      "page-size": _vm.dialogForm.page_size,
                      "page-sizes": [10, 20, 30, 40, 50, 100],
                      total: _vm.dialogTotal,
                    },
                    on: {
                      "size-change": function (size) {
                        return _vm.sizeChange(size, "dialogForm")
                      },
                      "current-change": function (page) {
                        return _vm.pageChange(page, "dialogForm")
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }